import { createContext, useState } from "react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IContextProfile, OrgPreferences, UserProfile } from "../../model/UserModel";
import { IAuthProvider } from '../AuthProvider/types';

import { GetActualUser } from "../../services/UserServices";
import { useAuth } from "../AuthProvider/useAuth";
import { OrganizationSigntureInformation } from "../../model/OrganizationModel";

export const ProfileContext = createContext<IContextProfile>({} as IContextProfile);


export const ProfileProvider = ({ children }: IAuthProvider) => {
    const[user, setUser] = useState<UserProfile|null>(null);
    const [userPicture, setUserPicture] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [userPhone, setUserphone] = useState<string>("");
    const [havePersonalDataModification, setHavePersonalDataModification] = useState<boolean>(false);
    const [signtureInformation, setSigntureInformation] = useState<OrganizationSigntureInformation|undefined>(undefined);

    const auth = useAuth();

    async function create (token : string|undefined) {
        if(token == undefined)
            throw console.error("Sem token");

        const response = await GetUser(token);
        if(response != null)
        {
            setHavePersonalDataModification(false);
            setUser(response);
        }else
        {
            throw console.error("Erro no profile");
        }
    };
    
    function remove() {
        setUser(null); 
    };
    
    const update = () => {
        setHavePersonalDataModification(true);
        console.log(auth.token)
        if(auth.token != undefined){
            create(auth.token);
        }
    }

    return (
        <ProfileContext.Provider value={{
            ...user, 
            create, 
            remove, 
            setUserPicture, 
            userPicture,
            setUsername,
            setUserphone,
            userPhone,
            username,
            setHavePersonalDataModification,
            havePersonalDataModification,
            update,
            setSigntureInformation,
            signtureInformation
        }}>
            {children}
        </ProfileContext.Provider>
    );
}

export async function GetUser(token: string){
    return GetActualUser(token)
        .then((userProfile) => {
            if(userProfile != undefined)
            {
                console.log(userProfile)
                return userProfile;
            }
            else
            {
                console.log("null")
                return null;
            }
        })
        .catch((error) => {
            return null;
        });
}